<div class="admin-sign-in-container">
  <h2>Admin - User Impersonation</h2>

  @if (isLoading) {
    <div class="loading-container">
      <p-progressSpinner aria-label="Loading"></p-progressSpinner>
    </div>
  } @else {
    <p-card>
      <div class="form-row">
        @if (!isSignedIn) {
          <div class="select-container">
            <p-select
              [(ngModel)]="selectedUserId"
              [options]="getUserOptions()"
              placeholder="Select a user"
              [filter]="true"
              filterPlaceholder="Search by email"
              [showClear]="true"
              appendTo="body"
              class="user-select">
            </p-select>
          </div>
        } @else {
          <div class="signed-in-info">
            <i class="pi pi-user"></i>
            <span>Signed in as: <strong>{{ signedInUserEmail }}</strong></span>
          </div>
        }

        <div class="button-container">
          @if (!isSignedIn) {
            <p-button
              label="Sign In"
              severity="primary"
              size="large"
              (onClick)="signIn()"
              [loading]="isSigningIn"
              [disabled]="!selectedUserId || isSigningIn">
            </p-button>
          } @else {
            <p-button
              label="Sign Out"
              severity="danger"
              size="large"
              (onClick)="signOut()"
              [disabled]="isSigningIn">
            </p-button>
          }
        </div>
      </div>
    </p-card>
  }
</div>